export const pointMap = {
  "SZ-G-H-X-jrtt-a124": "1749543359726595",
  "SZ-G-H-X-jrtt-a125": "1749543359726595",
  "SZ-G-H-X-jrtt-a126": "1749543359726595",
  "SZ-G-H-X-jrtt-a127": "1749543359726595",
  "SZ-G-H-X-jrtt-a128": "1749543359726595",
  "SZ-G-H-X-jrtt-q7": "1748351872300035",
  "SZ-G-H-X-jrtt-q8": "1748351872300035",
  "SZ-G-H-X-jrtt-q9": "1748351872300035",
  "SZ-G-H-X-jrtt-q10": "1748351872300035",
  "SZ-G-H-X-jrtt-q11": "1748351872300035",
  "SZ-G-H-X-jrtt-z16": "1748373590312003",
  "SZ-G-H-X-jrtt-z17": "1748373590312003",
  "SZ-G-H-X-jrtt-z18": "1748373590312003",
  "SZ-G-H-X-jrtt-z19": "1748373590312003",
  "SZ-G-H-X-jrtt-z23": "1748373590312003"
};
